module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[91]212.eaab85f.woff2";